/**
 * Ảnh QR trang chủ SAPA + địa chỉ chữ — thành phần THUẦN HIỂN THỊ dùng chung (docs/plans/san-pham-mien-phi-qr-ntfy.md nhóm B/C, ADR-114).
 *
 * KHÔNG nhận địa chỉ / mã / số điện thoại từ ngoài: chỉ nhận cỡ ảnh. Mã luôn là `dungQrSapa()` = chỉ hằng `TRANG_CHU_SAPA`,
 * nên mọi nơi dùng (màn Đăng nhập, mục nhân viên) không thể lỡ tay nhét mã đăng nhập vào QR. Có test đọc nguồn chữ ký + test giải mã.
 */
import { useMemo } from 'react'
import { dungQrSapa } from './qr-sapa.ts'
import { QS } from './text/qr-sapa.ts'

export function AnhQrSapa({ co }: { co: number }) {
  const { svg } = useMemo(() => dungQrSapa(), [])
  const anh = useMemo(() => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`, [svg])
  return (
    <div className="anh-qr-sapa">
      <img className="anh-qr-sapa-anh" src={anh} alt={QS.anhMoTa} width={co} height={co} />
      <p className="anh-qr-sapa-dia-chi">{QS.diaChi}</p>
    </div>
  )
}
